/*
 * @Description: 
 * @Author: 姜暖阳
 * @Date: 2021-10-21 15:15:57
 * @LastEditTime: 2023-10-08 11:05:46
 * @LastEditors: 赵大壮
 * @Reference: 
 */
import config from '../nyConfig'
const ApiJsonLogin = {
    "后台登录": new config({url: '/auth/managerLogin', showSuccessMessage: false, useToken: false }),
    "用户菜单": new config({url: '/manager/menu/getUserMenus', showSuccessMessage: false, useToken: true }),
}

export default ApiJsonLogin
